export enum Devices {
  phone = 'PHONE',
  tablet = 'TABLET',
  laptop = 'LAPTOP',
  desktop = 'DESKTOP'
}
